var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.297,
    height: 19.127,
    viewBox: "0 0 19.297 19.127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-edit",
    "data-name": "Icon feather-edit",
    transform: "translate(-2 -1.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12036",
    "data-name": "Path 12036",
    d: "M10.661,6H4.7A1.7,1.7,0,0,0,3,7.7V19.619a1.7,1.7,0,0,0,1.7,1.7H16.619a1.7,1.7,0,0,0,1.7-1.7V13.661",
    transform: "translate(0 -1.376)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12037",
    "data-name": "Path 12037",
    d: "M20.937,3.347A1.806,1.806,0,1,1,23.491,5.9L15.4,13.987l-3.4.851.851-3.4Z",
    transform: "translate(-3.893 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f3d84500e1c2c18b80e36677077fb36a.svg";
export { ForwardRef as ReactComponent };